import { Check } from "lucide-react";

import ImageFallback from "@/utils/ImageFallback";

import content from "@/content/about.json";

interface Data {
  title: string;
  bio: string;
  highlights: string[];
  image: string;
  alt: string;
}

const data: Data = content;

const AboutMe = () => {
  return (
    <section id="Sobre" className="py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          <div>
            <h2 className="font-display text-foreground text-4xl tracking-wide sm:text-5xl">
              {data.title}
            </h2>
            <p className="text-muted-foreground mt-6 text-lg leading-relaxed whitespace-break-spaces">
              {data.bio}
            </p>

            <ul className="mt-8 space-y-3">
              {data.highlights.map((item, index) => (
                <li
                  key={index}
                  className="text-muted-foreground flex items-start gap-3"
                >
                  <Check className="text-primary mt-0.5 h-5 w-5 shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="relative">
            <div className="border-border bg-card aspect-4/5 overflow-hidden rounded-2xl border">
              <ImageFallback
                className="h-full w-full object-cover"
                src={data.image}
                alt={data.alt}
              />
            </div>
            <div className="border-primary/30 bg-primary/5 absolute -right-1 -bottom-6 -z-10 h-full w-full rounded-2xl border md:-right-6" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;
